import { Check, CircleDashed, Loader } from 'lucide-react'
import { SonCta } from '../components/cta'
import { Reveal } from '../components/hareket'
import { Baslik, Rozet, SayfaUstu, Section, cn } from '../components/ui'
import { FAZLAR } from '../icerik/yol-haritasi'
import { useHead } from '../lib/head'

export function YolHaritasi() {
  useHead(
    {
      title: 'Yol haritası',
      description:
        'Akıllı Dernek’te ne hazır, ne geliştiriliyor, ne sırada. Tarih değil sıra veriyoruz; bitmemiş olan bitmemiş denir.',
    },
    '/yol-haritasi',
  )
  const ikon = { tamam: Check, suruyor: Loader, sirada: CircleDashed }
  const etiket = { tamam: 'Hazır', suruyor: 'Geliştiriliyor', sirada: 'Sırada' }
  const ton = { tamam: 'success', suruyor: 'warning', sirada: 'neutral' } as const
  return (
    <>
      <SayfaUstu>
        <Section className="pt-0 sm:pt-0" dar>
          <Reveal>
            <Baslik
              seviye="h1"
              eyebrow="Yol haritası"
              baslik="Ne hazır, ne sırada"
              metin="Sitede anlatılan her özellik ya bugün çalışıyor ya da bu listede. Tarih vermiyoruz, sıra veriyoruz: bir faz bitmeden sonrakine geçmiyoruz. İlk pilot derneklerin gerçek ihtiyacı sırayı değiştirebilir."
            />
          </Reveal>
          <ol className="mt-12 space-y-4">
            {FAZLAR.map((f, i) => {
              const Ikon = ikon[f.durum]
              return (
                <Reveal key={f.ad} delay={i * 0.05}>
                  <li
                    className={cn(
                      'rounded-[var(--radius-panel)] bg-surface p-6 ring-soft',
                      f.durum === 'suruyor' && 'ring-2 ring-brand',
                    )}
                  >
                    <div className="flex flex-wrap items-center gap-3">
                      <span
                        className={cn(
                          'grid size-9 place-items-center rounded-full',
                          f.durum === 'tamam' && 'bg-success/12 text-success',
                          f.durum === 'suruyor' && 'bg-brand text-on-brand',
                          f.durum === 'sirada' && 'bg-subtle text-ink-3',
                        )}
                      >
                        <Ikon className="size-4" aria-hidden />
                      </span>
                      <p className="data text-xs font-semibold uppercase tracking-wider text-ink-3">
                        {f.ad}
                      </p>
                      <p className="text-lg font-semibold text-ink">{f.baslik}</p>
                      <Rozet tone={ton[f.durum]} className="ml-auto">
                        {etiket[f.durum]}
                      </Rozet>
                    </div>
                    <ul className="mt-4 grid gap-x-6 gap-y-1.5 text-sm text-ink-2 sm:grid-cols-2">
                      {f.maddeler.map((m) => (
                        <li key={m} className="flex items-start gap-2">
                          <span
                            className={cn(
                              'mt-2 size-1.5 shrink-0 rounded-full',
                              f.durum === 'tamam' ? 'bg-success' : 'bg-line',
                            )}
                            aria-hidden
                          />
                          {m}
                        </li>
                      ))}
                    </ul>
                  </li>
                </Reveal>
              )
            })}
          </ol>
        </Section>
      </SayfaUstu>
      <SonCta
        baslik="Sırayı siz etkileyin."
        metin="Pilot derneklerle ayda bir görüşüyoruz; en çok istenen özellik öne geçiyor. Deneme hesabı açın, ihtiyacınızı panelden yazın."
      />
    </>
  )
}
